import { create } from 'zustand';

import { type Entitlements } from '@/api/types/entitlementsTypes';
import { type FavoriteId } from '@/api/types/favoriteTypes';
import { type HomeLocation } from '@/api/types/homeLocationTypes';
import { type KeyGenHeader } from '@/api/types/keyGenTypes';
import { type UserLocation } from '@/api/types/userLocationTypes';
import { type UserPreference } from '@/api/types/userPreferenceTypes';

export interface UserStore {
  info?: Foxkit.UserCookie;
  userLocation?: UserLocation;

  homeLocation?: HomeLocation | null;
  keyGenHeaders?: KeyGenHeader[] | undefined;
  userFavorites?: FavoriteId[];
  userPreference?: UserPreference;
  userEntitlements?: Entitlements;
  userUpcomingRecordings?: string[];
  userMetadata?: Foxkit.Auth.GetUserMetadataResponse;

  setHomeLocation: (homeLocation: HomeLocation | null | undefined) => void;
  setInfo: (info: Foxkit.UserCookie) => void;
  setKeyGenHeaders: (keyGenHeaders: KeyGenHeader[] | undefined) => void;
  setUserFavorites: (userFavorites: FavoriteId[] | undefined) => void;
  setUserLocation: (userLocation: UserLocation | undefined) => void;
  setUserPreference: (userPreference: UserPreference | undefined) => void;
  setUserEntitlements: (userEntitlements: Entitlements | undefined) => void;
  setUserUpcomingRecordings: (userUpcomingRecordings: string[] | undefined) => void;
  setUserMetadata: (userMetadata: Foxkit.Auth.GetUserMetadataResponse | undefined) => void;
  reloadUserUpcomingRecordings: () => void;
}

export const useUserStore = create<UserStore>()((set, get) => ({
  homeLocation: void 0,
  info: void 0,
  keyGenHeaders: void 0,
  userFavorites: void 0,
  userLocation: void 0,
  userPreference: void 0,
  userEntitlements: void 0,
  userUpcomingRecordings: void 0,
  userMetadata: void 0,

  setHomeLocation: (homeLocation?: HomeLocation | null) => {
    set({ homeLocation });
  },

  setInfo: (info?: Foxkit.UserCookie) => {
    set({ info });
  },

  setKeyGenHeaders: (keyGenHeaders?: KeyGenHeader[]) => {
    set({ keyGenHeaders });
  },

  setUserFavorites: (userFavorites?: FavoriteId[]) => {
    set({ userFavorites });
  },

  setUserLocation: (userLocation?: UserLocation) => {
    set({ userLocation });
  },

  setUserPreference: (userPreference?: UserPreference) => {
    set({ userPreference });
  },

  setUserEntitlements: (userEntitlements?: Entitlements) => {
    set({ userEntitlements });
  },

  setUserUpcomingRecordings: (userUpcomingRecordings?: string[]) => {
    set({ userUpcomingRecordings });
  },

  setUserMetadata: (userMetadata?: Foxkit.Auth.GetUserMetadataResponse) => {
    set({ userMetadata });
  },

  reloadUserUpcomingRecordings: () => {
    set({ userUpcomingRecordings: get().userUpcomingRecordings });
  },
}));
